import React from 'react';

import { ForumTopic } from '../../../../../../types';

import * as S from './styles';

type Props = {
  topic: ForumTopic;
};

export const Topic = ({ topic }: Props) => (
  // eslint-disable-next-line react/jsx-no-target-blank
  <S.ForumTopic href={topic?.uri ?? ''} target="_blank" rel="noopener">
    <span>{topic.title}</span>
    <S.LastPost>{topic.lastPost}</S.LastPost>
  </S.ForumTopic>
);
